import { ButtonTs, ResponsiveModal } from '@lt/components';
import { useTranslation } from '@lt/localization';
import React, { useState } from 'react';
import useSimpleCountdown from 'src/hooks/useSimpleCountdown';
import styles from './orderSuccess.module.css';

type Props = {
  title?: string;
  text?: string;
  goToOrderPage: () => void;
  needToRedirect: boolean;
  time: number;
};

const OrderSuccess = (props: Props) => {
  const { t } = useTranslation();
  const [isOpened, setIsOpened] = useState(true);

  const {
    title = t('commonPages.orderSuccess.orderPaid.title'),
    text = t('commonPages.orderSuccess.orderPaid.description'),
    goToOrderPage,
    needToRedirect,
    time,
  } = props;
  const secondsLeft = useSimpleCountdown(time);
  if (secondsLeft === 0 && needToRedirect) goToOrderPage();

  return (
    <ResponsiveModal
      center
      open={isOpened}
      onClose={() => setIsOpened(false)}
      styles={{ modal: { borderRadius: 6 } }}
    >
      <div
        className={styles.orderSuccessContainer}
        data-testid="ORDER_SUCCESS_POPUP"
      >
        <div className={styles.successIcon}>
          <div className={styles.check} />
        </div>
        <div className={styles.errorTitle}>{title}</div>
        <div className={styles.text}>{text}</div>
        {needToRedirect && secondsLeft >= 0 && (
          <div className={styles.text}>
            {t('commonPages.orderSuccess.countdown', { seconds: secondsLeft })}
          </div>
        )}
        <ButtonTs variant="primary" onClick={goToOrderPage}>
          {t('commonPages.orderSuccess.goToOrderPage')}
        </ButtonTs>
      </div>
    </ResponsiveModal>
  );
};
export default OrderSuccess;
